import { makeObservable, observable, computed, action } from 'mobx';
import { erpApiurl } from '../stores/APIEndpoints';

const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

const EMPTY_MESSAGE = { status: "", help: "" };
const ERROR_MESSAGE = { status: "error", help: "Unable to fetch the Locked Referrers. The Service is unavailable. Please try after sometime." };

export default class ReferrerStore {

    state = PENDING;
    message = EMPTY_MESSAGE;
    referrers = [];
    rowCount = 0;

    constructor(props) {
        this.apiProxy = props.apiProxy;

        makeObservable(this, {
            state: observable,
            message: observable,
            referrers: observable,
            rowCount: observable,

            isLoading: computed,
            isError: computed,
            isDone: computed,

            fetchReferrers: action,
            updateLock: action,
        });
    }


    get isLoading() {
        return this.state === PENDING;
    }

    get isError() {
        return this.state === ERROR;
    }

    get isDone() {
        return this.state === DONE;
    }

    updateLock = async (payLoad) => {
        const apiEndpoint = `${erpApiurl}api/CreditLimit/updateLock`;
        this.update(apiEndpoint,payLoad);
    }

    /**
    * 
    * Obtain the List of Locked Referrers from the .Net API endpoint
    * 
    */
     fetchReferrers = async () => {
        const apiEndpoint = `${erpApiurl}api/Creditlimit/GetLockedReferrers`;
        this.fetchData(apiEndpoint);
    }

    /**
     * Send the request to the endpoint using the FetchAPI
     * 
     */
    fetchData = async (url) => {

        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        try {
            const response = await this.apiProxy.getAsync(url);
            const data = await response.json();

            if (data.Message) {
                this.message = ERROR_MESSAGE;
                this.state = DONE;
                return;
            }
            this.referrers = data;
            this.rowCount = data.length;
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
    }

    update = async (apiEndPoint, payLoad) => {

        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        try {
            await this.apiProxy.asyncPost(apiEndPoint, payLoad);
            await this.fetchReferrers();
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
    }


}
